module.exports = __webpack_public_path__ + "img/pizza_three.9b2d6c82.png";